import { render, staticRenderFns } from "./RowBlockSkeleton.vue?vue&type=template&id=0160f875&scoped=true&"
import script from "./RowBlockSkeleton.vue?vue&type=script&lang=js&"
export * from "./RowBlockSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./RowBlockSkeleton.vue?vue&type=style&index=0&id=0160f875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160f875",
  null
  
)

export default component.exports